import * as Sentry from '@sentry/browser';
import { isInternalError } from './errors';

/* There are different ways to test/debug the Sentry error logging.
   - If the event/error is logged in Sentry but some data is missing, wrongly formatted,... you can inspect the
   raw content of the received event in Sentry itself. It is also the case that Sentry often indicates that something went wrong when parsing the JSON.
   For the methods listed below, you need to have Sentry configured. The easiest way to do so is to run in production mode (npm run build; npm run start).
   - If you want to see if breadcrumbs, user info,... get registered, there is no need to send an event/error to Sentry, but you can inspect them via the browser's console.
   At the moment of writing you can use __SENTRY__.hub._stack[0].scope to see for example which breadcrumbs are logged.
   - If you need to test the sending of events/errors to Sentry, you can trigger them via:
       1. typing something into the browser's console that will error: an undefined reference, an explicit `throw 'test'`,...
       2. adapting the code temporarily to send an error.
          To test the ErrorBoundary component you need to do so in code that is wrapped by that component.
          To test the error logging outside of the ErrorBoundary component, you can add a throw statement in one of the "start" components like YesplanAppFrame.
    Take into account that some adblockers block the communication to Sentry.
 */

export const setUserInSentryScope = (user) => {
  Sentry.getCurrentScope().setUser({
    id: user.id,
    name: user.name,
    email: user.email
  });
};

export const setHostInSentryScope = (host) => {
  Sentry.getCurrentScope().setTag('host', host);
};

export const setLocaleInSentryScope = (locale) => {
  Sentry.getCurrentScope().setTag('locale', locale);
};

export const addInfoBreadcrumbToSentry = (category, message, data) => {
  Sentry.getCurrentScope().setLevel('info');
  Sentry.addBreadcrumb({
    category,
    message,
    data: data || {}
  });
};

export const addWarningBreadcrumbToSentry = (category, message, data) => {
  Sentry.getCurrentScope().setLevel('warning');
  Sentry.addBreadcrumb({
    category,
    message,
    data: data || {}
  });
};

export const addCriticalBreadcrumbToSentry = (category, message, data) => {
  Sentry.getCurrentScope().setLevel('critical');
  Sentry.addBreadcrumb({
    category,
    message,
    data: data || {}
  });
};

export const sendToSentry = (event) => {
  if (process.env.NODE_ENV === 'production') {
    if (event instanceof Error) {
      if (!isInternalError(event)) Sentry.captureException(event);
    } else {
      let extras = { event };
      if (event instanceof Object) extras = { ...event };
      Sentry.captureException(new Error('Non-error object thrown'), {
        extra: extras
      });
    }
  } else if (event instanceof Error) {
    if (!isInternalError(event)) {
      console.log('[dev] Error logged:');
      console.error(event);
    }
  } else {
    console.log('[dev] Non-error object logged:');
    console.error(event);
  }
};